export const row8 = [
  {
    result: "grid_4",
    startX: 323.1961954938812,
    rows: 8,
  },
  {
    result: "grid_4",
    startX: 352.7162812935247,
    rows: 8,
  },
  {
    result: "grid_2",
    startX: 257.68869759470294,
    rows: 8,
  },
  {
    result: "grid_4",
    startX: 338.936499030933,
    rows: 8,
  },
  
 
  {
    result: "grid_6",
    startX: 467.76528300803943,
    rows: 8,
  },
  {
    result: "grid_6",
    startX: 333.9243014562265,
    rows: 8,
  },
  {
    result: "grid_4",
    startX: 415.94394391607733,
    rows: 8,
  },
 
 
  {
    result: "grid_3",
    startX: 301.2966762131334,
    rows: 8,
  },
 
 
  
 
  // {
  //   result: "grid_6",
  //   startX: 265.7269584440114,
  //   rows: 8,
  // },
  {
    result: "grid_6",
    startX: 421.9896832257823,
    rows: 8,
  },
  
  
  {
    result: "grid_7",
    startX: 468.59897371123435,
    rows: 8,
  },
  
 
 
  {
    result: "grid_1",
    startX: 318.1332333374281,
    rows: 8,
  },
  {
    result: "grid_6",
    startX: 334.7327361589722,
    rows: 8,
  },
  
  
  {
    result: "grid_7",
    startX: 463.03529720856784,
    rows: 8,
  },
  {
    result: "grid_5",
    startX: 431.656134903469,
    rows: 8,
  },
  {
    result: "grid_5",
    startX: 393.51656599221826,
    rows: 8,
  },

  {
    result: "grid_5",
    startX: 373.6710000348769,
    rows: 8,
  },
  {
    result: "grid_5",
    startX: 357.5726603321711,
    rows: 8,
  },
 
  
  {
    result: "grid_8",
    startX: 442.9070060944438,
    rows: 8,
  },
  




  
 

  
  {
    result: "grid_3",
    startX: 387.1639862754746,
    rows: 8,
  },
  {
    result: "grid_1",
    startX: 256.82796486860946,
    rows: 8,
  },
  {
    result: "grid_1",
    startX: 314.49049217867395,
    rows: 8,
  },
  
 
  {
    result: "grid_3",
    startX: 271.8483553057395,
    rows: 8,
  },
  
  {
    result: "grid_7",
    startX: 464.74598347017957,
    rows: 8,
  },
  
  {
    result: "grid_6",
    startX: 440.7741663748559,
    rows: 8,
  },
 
  
 

  {
    result: "grid_2",
    startX: 276.70240717913697,
    rows: 8,
  },
  
  
 
  {
    result: "grid_6",
    startX: 458.0583634179514,
    rows: 8,
  },
  
  
 
  
  {
    result: "grid_7",
    startX: 410.48854460715677,
    rows: 8,
  },
  {
    result: "grid_7",
    startX: 402.361016377959,
    rows: 8,
  },
 
  {
    result: "grid_8",
    startX: 402.81459171775793,
    rows: 8,
  },
 

  {
    result: "grid_6",
    startX: 414.7151610559399,
    rows: 8,
  },

 
  
 
  {
    result: "grid_0",
    startX: 318.21777011406016,
    rows: 8,
  },
  
  



];

export const row9 = [

  {
    result: "grid_5",
    startX: 389.27304151744096,
    rows: 9,
  },
 
  {
    result: "grid_5",
    startX: 341.45573980301833,
    rows: 9,
  },
  {
    result: "grid_5",
    startX: 364.2903707909395,
    rows: 9,
  },
  
  {
    result: "grid_5",
    startX: 350.3073273593714,
    rows: 9,
  },
 
  {
    result: "grid_3",
    startX: 363.753176860531,
    rows: 9,
  },
  {
    result: "grid_6",
    startX: 397.12448823430185,
    rows: 9,
  },
 

  {
    result: "grid_3",
    startX: 342.43227099671066,
    rows: 9,
  },
  
  {
    result: "grid_5",
    startX: 409.62579806712967,
    rows: 9,
  },
  
  {
    result: "grid_7",
    startX: 399.1030017935251,
    rows: 9,
  },
  

  {
    result: "grid_4",
    startX: 305.2539196014622,
    rows: 9,
  },

  {
    result: "grid_5",
    startX: 342.7013452037887,
    rows: 9,
  },
  {
    result: "grid_6",
    startX: 425.51358367679063,
    rows: 9,
  },
 
  {
    result: "grid_6",
    startX: 394.8661808002235,
    rows: 9,
  },
 
  
  
  {
    result: "grid_6",
    startX: 371.8651310553445,
    rows: 9,
  },

 
  {
    result: "grid_6",
    startX: 359.48358855955644,
    rows: 9,
  },


  {
    result: "grid_8",
    startX: 376.36663471241343,
    rows: 9,
  },
 
  // {
  //   result: "grid_2",
  //   startX: 281.7243365379126,
  //   rows: 9,
  // },
 

  {
    result: "grid_7",
    startX: 396.1881896369231,
    rows: 9,
  },
 
  {
    result: "grid_4",
    startX: 310.2065272247768,
    rows: 9,
  },
  {
    result: "grid_2",
    startX: 406.5073977890406,
    rows: 9,
  },
 
  {
    result: "grid_2",
    startX: 320.79489024947026,
    rows: 9,
  },

  {
    result: "grid_2",
    startX: 288.218222025952,
    rows: 9,
  },



];

export const row10 = [
  {
    result: "grid_5",
    startX: 335.36563701713135,
    rows: 10,
  },

  // {
  //     "result": "grid_6",
  //     "startX": 392.58349121270095,
  //     "rows": 10
  // },
  {
    result: "grid_5",
    startX: 389.378364886883,
    rows: 10,
  },
  {
    result: "grid_5",
    startX: 353.79575661774,
    rows: 10,
  },
  // {
  //     "result": "grid_6",
  //     "startX": 365.40970044433146,
  //     "rows": 10
  // },

  {
    result: "grid_4",
    startX: 353.42894131232606,
    rows: 10,
  },
  {
    result: "grid_4",
    startX: 397.1203612747264,
    rows: 10,
  },
  
  // {
  //   result: "grid_1",
  //   startX: 348.58620091287344,
  //   rows: 10,
  // },
  {
    result: "grid_6",
    startX: 399.35628547429747,
    rows: 10,
  },

  
  {
    result: "grid_4",
    startX: 348.24952790704896,
    rows: 10,
  },

  {
    result: "grid_7",
    startX: 369.9849541322347,
    rows: 10,
  },

  {
    result: "grid_4",
    startX: 349.7799135461957,
    rows: 10,
  },
 

  {
    result: "grid_7",
    startX: 422.7536377623059,
    rows: 10,
  },
  {
    result: "grid_7",
    startX: 394.5226542460142,
    rows: 10,
  },

  
  {
    result: "grid_7",
    startX: 373.31940261305215,
    rows: 10,
  },
 

  {
    result: "grid_6",
    startX: 400.279744877586,
    rows: 10,
  },
  {
    result: "grid_8",
    startX: 371.86929393360316,
    rows: 10,
  },

  {
    result: "grid_7",
    startX: 371.39860208532593,
    rows: 10,
  },

  {
    result: "grid_3",
    startX: 290.38049073480653,
    rows: 10,
  },

  {
    result: "grid_6",
    startX: 408.5807636252312,
    rows: 10,
  },

  {
    result: "grid_8",
    startX: 368.7047817224151,
    rows: 10,
  },
  {
    result: "grid_8",
    startX: 430.1313901581629,
    rows: 10,
  },


  {
    result: "grid_10",
    startX: 394.41901145425936,
    rows: 10,
  },

  {
    result: "grid_8",
    startX: 371.4526387253228,
    rows: 10,
  },

  {
    result: "grid_3",
    startX: 292.3076279697792,
    rows: 10,
  },

  {
    result: "grid_3",
    startX: 326.3869928153394,
    rows: 10,
  },

 
];

export const row11 = [
  {
    result: "grid_11",
    startX: 336.56553716625865,
    rows: 11,
  },
  {
    result: "grid_10",
    startX: 291.0681232061984,
    rows: 11,
  },
 
  {
    result: "grid_10",
    startX: 293.107601072676,
    rows: 11,
  },
  
  
 
 
  {
    result: "grid_11",
    startX: 330.88530694507887,
    rows: 11,
  },

  {
    result: "grid_3",
    startX: 294.3207702965472,
    rows: 11,
  },

  // {
  //   result: "grid_5",
  //   startX: 308.8946102100288,
  //   rows: 11,
  // },
  // {
  //   result: "grid_5", // 1
  //   startX: 312.8609407386142,
  //   rows: 11,
  // },
  
  {
    result: "grid_9",
    startX: 344.62450825229877,
    rows: 11,
  },
  
 
  {
    result: "grid_11",
    startX: 329.7937673654987,
    rows: 11,
  },
  

  {
    result: "grid_0",
    startX: 283.08944022281617,
    rows: 11,
  },
 
  
  
  {
    result: "grid_5",
    startX: 340.5523848243829,
    rows: 11,
  },
 
  {
    result: "grid_9",
    startX: 337.90858276271666,
    rows: 11,
  },
  
  {
    result: "grid_9",
    startX: 287.79580812455987,
    rows: 11,
  },
  
 
  {
    result: "grid_8",
    startX: 331.08879518181146,
    rows: 11,
  },
  {
    result: "grid_8",
    startX: 337.8618446222792,
    rows: 11,
  },

 

  {
    result: "grid_11",
    startX: 325.9787552620674,
    rows: 11,
  },

 
  {
    result: "grid_8",
    startX: 335.54335398136595,
    rows: 11,
  },
 
  {
    result: "grid_10",
    startX: 305.68673503449116,
    rows: 11,
  },
  {
    result: "grid_10",
    startX: 290.7345020954386,
    rows: 11,
  },
  
  
  {
    result: "grid_6",
    startX: 313.3174655118037,
    rows: 11,
  },
  {
    result: "grid_6",
    startX: 295.5965744232113,
    rows: 11,
  },


  {
    result: "grid_3",
    startX: 345.96283417576296,
    rows: 11,
  },
  {
    result: "grid_3",
    startX: 356.7100289457351,
    rows: 11,
  },
  {
    result: "grid_4",
    startX: 325.5559113259072,
    rows: 11,
  },
  

 
  {
    result: "grid_3",
    startX: 292.05008233140336,
    rows: 11,
  },
  {
    result: "grid_7",
    startX: 361.56287573242207,
    rows: 11,
  },
  {
    result: "grid_7",
    startX: 300.42365975698056,
    rows: 11,
  },

 
 
 
  {
    result: "grid_3",
    startX: 358.0785564185014,
    rows: 11,
  },
  
  {
    result: "grid_1",
    startX: 322.38697557338236,
    rows: 11,
  },
    {
    result: "grid_3",
    startX: 357.5579700925432,
    rows: 11,
  },

  
  {
    result: "grid_0",
    startX: 294.15637426073175,
    rows: 11,
  },
  {
    result: "grid_10",
    startX: 290.15637426073175,
    rows: 11
  },
  {
    result: "gird_1",
    startX: 288.15637426073175,
    rows: 11
  },


 
  // {
  //   result: "grid_3",
  //   startX: 332.05417289803665,
  //   rows: 11,
  // },
  {
    result: "grid_3",
    startX: 294.3780982232731,
    rows: 11,
  },

  // {
  //   result: "grid_3",
  //   startX: 361.1687689348053,
  //   rows: 11,
  // },
  
 
  {
    result: "grid_3",
    startX: 291.9089247558882,
    rows: 11,
  },
  
];

export const row12 = [
 
  {
    result: "grid_5",
    startX: 298.96285722764054,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 347.28469122362253,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 400.93792334245234,
    rows: 12
  },
  {
    result: "grid_9",
    startX: 336.49621536147373,
    rows: 12,
  },
  {
    result: "grid_9",
    startX: 304.90963035898307,
    rows: 12,
  },
  {
    result: "grid_3",
    startX: 327.95030142645635,
    rows: 12,
  },
  {
    result: "grid_6",
    startX: 354.31788051380727,
    rows: 12,
  },
 
  {
    result: "grid_6",
    startX: 354.3875490504722,
    rows: 12,
  },
  {
    result: "grid_7",
    startX: 334.7077122808355,
    rows: 12,
  },
 
  {
    result: "grid_6",
    startX: 328.13843832512174,
    rows: 12,
  },
  {
    result: "grid_5",
    startX: 312.02843274326324,
    rows: 12,
  },
  {
    result: "grid_5",
    startX: 343.2847839767105,
    rows: 12,
  },
  {
    result: "grid_9",
    startX: 331.59142770963194,
    rows: 12,
  },
  {
    result: "grid_7",
    startX: 339.5666119961421,
    rows: 12,
  },
  {
    result: "grid_7",
    startX: 327.01239910407975,
    rows: 12,
  },
  {
    result: "grid_7",
    startX: 355.4882176025824,
    rows: 12,
  },
  {
    result: "grid_6",
    startX: 334.6943529923832,
    rows: 12,
  },
 
  {
    result: "grid_10",
    startX: 305.0054115270938,
    rows: 12,
  },
 
  {
    result: "grid_9",
    startX: 332.9670156032735,
    rows: 12,
  },
  {
    result: "grid_5",
    startX: 306.76509961207,
    rows: 12,
  },
  
  {
    result: "grid_7",
    startX: 298.98302687078655,
    rows: 12,
  },
  
  
  {
    result: "grid_3",
    startX: 304.7710421370715,
    rows: 12,
  },
  {
    result: "grid_4",
    startX: 323.17743838601825,
    rows: 12,
  },
  
  {
    result: "grid_4",
    startX: 329.22161405936885,
    rows: 12,
  },
  
  {
    result: "grid_5",
    startX: 336.55059359994294,
    rows: 12,
  },
  {
    result: "grid_5",
    startX: 337.1888783387625,
    rows: 12,
  },
 
  {
    result: "grid_0",
    startX: 135.39376317917754,
    rows: 12
  },
  {
    result: "grid_1",
    startX: 316.07467998804367,
    rows: 12,
  },
  {
    result: "grid_3",
    startX: 322.82232714180105,
    rows: 12,
  },
 
  {
    result: "grid_4",
    startX: 321.3022449620689,
    rows: 12,
  },
  
 
 
  {
    result: "grid_4",
    startX: 320.12259793156807,
    rows: 12,
  },
  {
    result: "grid_4",
    startX: 328.66455072055095,
    rows: 12,
  },

  {
    result: "grid_1",
    startX: 311.5170831893437,
    rows: 12,
  },
 
  {
    result: "grid_7",
    startX: 290.2331058991303,
    rows: 12,
  },
 


 
 
  {
    result: "grid_2",
    startX: 311.1695826436443,
    rows: 12,
  },
 
  
  {
    result: "grid_10",
    startX: 328.60603554214055,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 325.67735278430484,
    rows: 12,
  },
 
  
 

  {
    result: "grid_8",
    startX: 334.930815785795,
    rows: 12,
  },
  {
    result: "grid_8",
    startX: 329.75715333766686,
    rows: 12,
  },
  {
    result: "grid_8",
    startX: 313.8192711273324,
    rows: 12,
  },

  

  {
    result: "grid_12",
    startX: 327.93792334245234,
    rows: 12,
  },

  
 
 
 
  {
    result: "grid_10",
    startX: 340.35631006804397,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 328.44409257634385,
    rows: 12,
  },
 

 
  {
    result: "grid_10",
    startX: 333.22820934325676,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 332.5333979552444,
    rows: 12,
  },
  
  {
    result: "grid_10",
    startX: 339.2561531378484,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 332.0036084558712,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 330.2899931287118,
    rows: 12,
  },
 
  {
    result: "grid_11",
    startX: 325.62841540578995,
    rows: 12,
  },
  {
    result: "grid_11",
    startX: 403.93792334245234,
    rows: 12
  },

 
 
 
 

  {
    result: "grid_10",
    startX: 332.5341394224903,
    rows: 12,
  },
  {
    result: "grid_10",
    startX: 338.51669137061083,
    rows: 12,
  },
  
 
  
  
  
  {
    result: "grid_10",
    startX: 346.50272114866783,
    rows: 12,
  },
  
  
  
  {
    result: "grid_10",
    startX: 330.3072166260734,
    rows: 12,
  },
  
 
  {
    result: "grid_10",
    startX: 333.43495994341015,
    rows: 12,
  },
];

export const row13 = [
  {
    result: "grid_4",
    startX: 263.88626949852755,
    rows: 13,
  },
  {
    result: "grid_7",
    startX: 339.26147142937174,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 292.9514513783942,
    rows: 13,
  },
  {
    result: "grid_4",
    startX: 283.1411484432711,
    rows: 13,
  },
  {
    result: "grid_5",
    startX: 319.8851743196605,
    rows: 13,
  },
  {
    result: "grid_7",
    startX: 325.21475925465904,
    rows: 13,
  },
  {
    result: "grid_7",
    startX: 402.6904711238258,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 265.27009099926136,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 308.3120588064585,
    rows: 13,
  },
  {
    result: "grid_5",
    startX: 251.3893965780149,
    rows: 13,
  },
  {
    result: "grid_5",
    startX: 322.21005443416414,
    rows: 13,
  },
  {
    result: "grid_5",
    startX: 318.3952235813958,
    rows: 13,
  },
  {
    result: "grid_11",
    startX: 391.56309132355227,
    rows: 13,
  },
  {
    result: "grid_7",
    startX: 310.3380562174094,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 324.2657047318393,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 349.2585498428973,
    rows: 13,
  },
  {
    result: "grid_8",
    startX: 329.6455261204909,
    rows: 13,
  },
  {
    result: "grid_8",
    startX: 348.82401174710736,
    rows: 13,
  },
 
  {
    result: "grid_8",
    startX: 367.7094492675476,
    rows: 13,
  },
  {
    result: "grid_8",
    startX: 365.2619108181857,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 292.24606240639736,
    rows: 13,
  },
  {
    result: "grid_8",
    startX: 372.37934617473604,
    rows: 13,
  },
  
  {
    result: "grid_7",
    startX: 288.4648814113348,
    rows: 13,
  },
  {
    result: "grid_7",
    startX: 356.02975587486145,
    rows: 13,
  },
  {
    result: "grid_8",
    startX: 327.47178019472,
    rows: 13,
  },
 
  {
    result: "grid_12",
    startX: 389.0920146610632,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 291.6542286737914,
    rows: 13,
  },
  {
    result: "grid_10",
    startX: 329.9878264265049,
    rows: 13,
  },
  {
    result: "grid_10",
    startX: 416.05400471095743,
    rows: 13,
  },
  {
    result: "grid_10",
    startX: 337.52059962310966,
    rows: 13,
  },
  {
    result: "grid_5",
    startX: 316.7961529181797,
    rows: 13,
  },
  {
    result: "grid_5",
    startX: 307.94883415888063,
    rows: 13,
  },
  {
    result: "grid_10",
    startX: 331.1014940904689,
    rows: 13,
  },
  
 
  {
    result: "grid_5",
    startX: 298.3550408747855,
    rows: 13,
  },
  {
    result: "grid_7",
    startX: 328.48386435120995,
    rows: 13,
  },
  
  {
    result: "grid_12",
    startX: 416.20074236795745,
    rows: 13,
  },
  {
    result: "grid_12",
    startX: 393.0449792703113,
    rows: 13,
  },
 

  {
    result: "grid_9",
    startX: 308.9417434499327,
    rows: 13,
  },
  {
    result: "grid_9",
    startX: 354.5746381809834,
    rows: 13,
  },
  
  {
    result: "grid_9",
    startX: 321.11439286402805,
    rows: 13,
  },
 
  {
    result: "grid_6",
    startX: 354.85528589707565,
    rows: 13,
  },
  {
    result: "grid_6",
    startX: 383.26814929840367,
    rows: 13,
  },
  
  

  {
    result: "grid_4",
    startX: 305.426675979172,
    rows: 13,
  },
 
  {
    result: "grid_6",
    startX: 314.6800512500335,
    rows: 13,
  },
  {
    result: "grid_4",
    startX: 297.1355932384168,
    rows: 13,
  },
 


  {
    result: "grid_6",
    startX: 326.5170135901294,
    rows: 13,
  },
  

  {
    result: "grid_10",
    startX: 382.6055253671068,
    rows: 13,
  },

  {
    result: "grid_2",
    startX: 244.65419226048596,
    rows: 13,
  },
  {
    result: "grid_2",
    startX: 259.1439576605571,
    rows: 13,
  },


  {
    result: "grid_4",
    startX: 264.4801814493867,
    rows: 13,
  },
 


  // {
  //   result: "grid_3",
  //   startX: 284.59322119381983,
  //   rows: 13,
  // },
  // {
  //   result: "grid_3",
  //   startX: 259.14391602932943,
  //   rows: 13,
  // },


  {
    result: "grid_3",
    startX: 260.0178236323577,
    rows: 13,
  },


  {
    result: "grid_1",
    startX: 238.1465488413864,
    rows: 13,
  },
  {
    result: "grid_0",
    startX: "182.739537902814",
    rows: 13
  },

 
  {
    result: "grid_1",
    startX: 243.84999214109584,
    rows: 13,
  },

  {
    result: "grid_12",
    startX: 392.13195487377845,
    rows: 13,
  },

  {
    result: "grid_13",
    startX: 393.96904744230335,
    rows: 13
  },
  {
    result: "grid_12",
    startX: 416.1208524967252,
    rows: 13,
  },
  {
    result: "grid_12",
    startX: 392.96904744230335,
    rows: 13,
  },
 
  {
    result: "grid_3",
    startX: 261.6324202286662,
    rows: 13,
  },
  


];

export const row14 = [
  // {
  //   result: "grid_2",
  //   startX: 250.52276710406517,
  //   rows: 14,
  // },
  {
    result: "grid_8",
    startX: 330.2323125997503,
    rows: 14,
  },
 
  {
    result: "grid_9",
    startX: 365.09066694150255,
    rows: 14,
  },
  {
    result: "grid_7",
    startX: 340.2669022137327,
    rows: 14,
  },
  {
    result: "grid_7",
    startX: 325.2575119252831,
    rows: 14,
  },
  {
    result: "grid_7",
    startX: 350.10431759190726,
    rows: 14,
  },
  {
    result: "grid_6",
    startX: 288.2694320410065,
    rows: 14,
  },
  {
    result: "grid_6",
    startX: 256.05328087413056,
    rows: 14,
  },
  // {
  //   result: "grid_1",
  //   startX: 259.5310180057997,
  //   rows: 14,
  // },
 
  {
    result: "grid_5",
    startX: 320.81255831512215,
    rows: 14,
  },
  
  {
    result: "grid_8",
    startX: 350.1470783086179,
    rows: 14,
  },
  {
    result: "grid_8",
    startX: 337.9226103965496,
    rows: 14,
  },
  {
    result: "grid_7",
    startX: 312.07668055329,
    rows: 14,
  },
  {
    result: "grid_7",
    startX: 327.68383573080564,
    rows: 14,
  },
  
  {
    result: "grid_5",
    startX: 273.9391473189007,
    rows: 14,
  },
  {
    result: "grid_7",
    startX: 353.69245804104116,
    rows: 14,
  },
 
  {
    result: "grid_8",
    startX: 325.68592779694256,
    rows: 14,
  },

  {
    result: "grid_8",
    startX: 331.72540417273007,
    rows: 14,
  },
 
  {
    result: "grid_9",
    startX: 330.42161381111,
    rows: 14,
  },
  
  
  {
    result: "grid_5",
    startX: 268.7404750054096,
    rows: 14,
  },

  {
    result: "grid_8",
    startX: 330.51669342616174,
    rows: 14,
  },
  
 
 
  {
    result: "grid_12",
    startX: 392.03233097960197,
    rows: 14,
  },
  {
    result: "grid_6",
    startX: 290.41582963149136,
    rows: 14,
  },
  
  {
    result: "grid_2",
    startX: 264.73647978753996,
    rows: 14,
  },


  {
    result: "grid_7",
    startX: 348.7545369666451,
    rows: 14,
  },
 
 
  {
    result: "grid_9",
    startX: 371.61451077371265,
    rows: 14,
  },

  {
    result: "grid_9",
    startX: 361.5876689624422,
    rows: 14,
  },
  {
    result: "grid_9",
    startX: 395.8480908637962,
    rows: 14,
  },

  {
    result: "grid_12",
    startX: 382.9430204891544,
    rows: 14,
  },
  
  {
    result: "grid_6",
    startX: 289.2928605293095,
    rows: 14,
  },
 
  {
    result: "grid_7",
    startX: 379.1868344234915,
    rows: 14,
  },
  

 
  {
    result: "grid_9",
    startX: 344.8239756584205,
    rows: 14,
  },
 
 

  
  {
    result: "grid_12",
    startX: 387.63297205275626,
    rows: 14,
  },
  
 

  {
    result: "grid_13",
    startX: 402.61379664382343,
    rows: 14
  },
  {
    result: "grid_14",
    startX: 405.61379664382343,
    rows: 14
  },
 
 
 
 
  {
    result: "grid_1",
    startX: 281.3562008048029,
    rows: 14,
  },
  
  {
    result: "grid_3",
    startX: 265.75635439566474,
    rows: 14,
  },

  {
    result: "grid_5",
    startX: 285.14893151659476,
    rows: 14,
  },
 

  {
    result: "grid_4",
    startX: 281.90604360128617,
    rows: 14,
  },
  {
    result: "grid_4",
    startX: 250.15635439566474,
    rows: 14
  },
  {
    result: "grid_2",
    startX: 260.9604360128617,
    rows:14
  },
  {
    result: "grid_0",
    startX: 262.9604360128617,
    rows: 14
  },
  
  
  {
    result: "grid_11",
    startX: 387.4654625378331,
    rows: 14,
  },
  {
    result: "grid_6",
    startX: 318.3701661823404,
    rows: 14,
  },
  {
    result: "grid_6",
    startX: 341.95696556142804,
    rows: 14,
  },
  

  {
    result: "grid_12",
    startX: 390.61747281256964,
    rows: 14,
  },
 
  
  {
    result: "grid_3",
    startX: 281.8197697326567,
    rows: 14,
  },
  {
    result: "grid_11",
    startX: 389.72630820719417,
    rows: 14,
  },
 

  {
    result: "grid_12",
    startX: 366.61379664382343,
    rows: 14,
  },
];

export const row15 = [
  {
    result: "grid_7",
    startX: 313.1647914559578,
    rows: 15,
  },
  {
    result: "grid_15",
    startX:455.0231005041718,
    rows: 15
  },
  
  {
    result: "grid_6",
    startX: 320.2524265012421,
    rows: 15,
  },
  {
    result: "grid_0",
    startX: 266.8685813924554,
    rows: 15,
  },
  {
    result: "grid_8",
    startX: 330.5656037517905,
    rows: 15,
  },
  {
    result: "grid_7",
    startX: 324.34967115373223,
    rows: 15,
  },
 
  {
    result: "grid_9",
    startX: 329.986283590518,
    rows: 15,
  },
  {
    result: "grid_8",
    startX: 332.5772992544164,
    rows: 15,
  },
  {
    result: "grid_11",
    startX: 388.01082886759446,
    rows: 15,
  },
  {
    result: "grid_7",
    startX: 302.83260642447954,
    rows: 15,
  },
  
 
  {
    result: "grid_8",
    startX: 335.6496211398172,
    rows: 15,
  },
  
  
  {
    result: "grid_7",
    startX: 280.31806452342096,
    rows: 15,
  },
 
 
  
  {
    result: "grid_9",
    startX: 329.66760214358413,
    rows: 15,
  },
  {
    result: "grid_8",
    startX: 337.1106068504091,
    rows: 15,
  },
  
  {
    result: "grid_0",
    startX: 286.18199066910927,
    rows: 15,
  },
 
  {
    result: "grid_9",
    startX: 329.0935061483961,
    rows: 15,
  },
 
 
  {
    result: "grid_4",
    startX: 265.53748223939675,
    rows: 15,
  },
  
 
  {
    result: "grid_9",
    startX: 360.8903052524008,
    rows: 15,
  },
  {
    result: "grid_14",
    startX: 386.0231005041718,
    rows: 15,
  },
  
 
  
  {
    result: "grid_8",
    startX: 339.9790914654411,
    rows: 15,
  },
  
  {
    result: "grid_2",
    startX: 271.4869706207347,
    rows: 15,
  },
  {
    result: "grid_8",
    startX: 356.22128416375165,
    rows: 15,
  },
  {
    result: "grid_6",
    startX: 290.66070771661845,
    rows: 15,
  },
  
  
 
  {
    result: "grid_6",
    startX: 323.4591287481803,
    rows: 15,
  },
  
 
  {
    result: "grid_11",
    startX: 380.6785599302207,
    rows: 15,
  },
  {
    result: "grid_11",
    startX: 378.0087673924145,
    rows: 15,
  },
 
 
  {
    result: "grid_6",
    startX: 321.2170168017288,
    rows: 15,
  },
 
  {
    result: "grid_7",
    startX: 316.14117294485953,
    rows: 15,
  },
  
 
 
 
  
  {
    result: "grid_9",
    startX: 366.3938170695104,
    rows: 15,
  },
 
 
 
  {
    result: "grid_6",
    startX: 257.23237068944024,
    rows: 15,
  },
 
  {
    result: "grid_5",
    startX: 319.897407206573,
    rows: 15,
  },
  
 
  {
    result: "grid_14",
    startX: 398.13666586802844,
    rows: 15,
  },
  
  {
    result: "grid_6",
    startX: 284.643180186529,
    rows: 15,
  },
 
 
  {
    result: "grid_8",
    startX: 318.5193344640487,
    rows: 15,
  },
 
  {
    result: "grid_12",
    startX: 379.7258350437372,
    rows: 15,
  },
  {
    result: "grid_12",
    startX: 364.1949853046217,
    rows: 15,
  },
 
 
  
  {
    result: "grid_6",
    startX: 280.07608012717236,
    rows: 15,
  },
 
  {
    result: "grid_5",
    startX: 287.61332795274546,
    rows: 15,
  },
 
  // {
  //   result: "grid_6",
  //   startX: 341.3454340307338,
  //   rows: 15,
  // },
  {
    result: "grid_10",
    startX: 329.7756809173734,
    rows: 15,
  },
 
  {
    result: "grid_9",
    startX: 368.18031466940903,
    rows: 15,
  },

  {
    result: "grid_4",
    startX: 265.14730161225,
    rows: 15,
  },
  // {
  //   result: "grid_6",
  //   startX: 302.5574825742696,
  //   rows: 15,
  // },
 
  // {
  //   result: "grid_6",
  //   startX: 282.20344628730084,
  //   rows: 15,
  // },
 
  {
    result: "grid_13",
    startX: 384.5449129286296,
    rows: 15,
  },
 
  // {
  //   result: "grid_6",
  //   startX: 282.6776501320524,
  //   rows: 15,
  // },
  
  {
    result: "grid_2",
    startX: 268.55191425003324,
    rows: 15,
  },
 
  {
    result: "grid_3",
    startX: 267.84422419199177,
    rows: 15,
  },
  
  // {
  //   result: "grid_6",
  //   startX: 280.68395504520413,
  //   rows: 15,
  // },
 
  
  
  // {
  //   result: "grid_6",
  //   startX: 306.08935169289947,
  //   rows: 15,
  // },
  // {
  //   result: "grid_6",
  //   startX: 278.6206093867505,
  //   rows: 15,
  // },
  // {
  //   result: "grid_6",
  //   startX: 316.9567344807654,
  //   rows: 15,
  // },
  // {
  //   result: "grid_6",
  //   startX: 275.52045219073636,
  //   rows: 15,
  // },
 
  {
    result: "grid_3",
    startX: 268.56232880794124,
    rows: 15,
  },
 
 
  {
    result: "grid_3",
    startX: 271.248242301898,
    rows: 15,
  },
  // {
  //   result: "grid_6",
  //   startX: 244.34899177510096,
  //   rows: 15,
  // },
  // {
  //   result: "grid_6",
  //   startX: 283.417725009881,
  //   rows: 15,
  // },
  {
    result: "grid_2",
    startX: 262.07596072908154,
    rows: 15,
  },
  // {
  //   result: "grid_6",
  //   startX: 319.3412148128947,
  //   rows: 15,
  // },

  {
    result: "grid_5",
    startX: 267.09914233772804,
    rows: 15,
  },
  
  
  {
    result: "grid_12",
    startX: 397.8971246120534,
    rows: 15,
  },
  
  // {
  //   result: "grid_6",
  //   startX: 319.32018363365427,
  //   rows: 15,
  // },
  // {
  //   result: "grid_6",
  //   startX: 283.5730291636718,
  //   rows: 15,
  // },
  {
    result: "grid_5",
    startX: 283.8697793756519,
    rows: 15,
  },
 
  
  {
    result: "grid_1",
    startX: 267.59465755045477,
    rows: 15,
  },
  
 
  {
    result: "grid_8",
    startX: 325.1903751193924,
    rows: 15,
  },
  
  // {
  //   result: "grid_6",
  //   startX: 318.1282329434077,
  //   rows: 15,
  // },
  // {
  //   result: "grid_6",
  //   startX: 354.6455633016713,
  //   rows: 15,
  // },
  {
    result: "grid_13",
    startX: 382.2122521459096,
    rows: 15,
  },
  
  {
    result: "grid_11",
    startX: 364.090719300131,
    rows: 15,
  },
  {
    result: "grid_12",
    startX: 364.83635664633294,
    rows: 15,
  },
  {
    result: "grid_14",
    startX: 382.2102612181958,
    rows: 15,
  },
  {
    result: "grid_14",
    startX: 400.28651690184677,
    rows: 15,
  },
 
  {
    result: "grid_0",
    startX: 248.28199845992802,
    rows: 15,
  }
];

export const row16 = [
  {
    result: "grid_0",
    startX: 102.32471037484845,
    rows:16
  },
  {
    result: "grid_1",
    startX: 100.32471037484845,
    rows: 16
  },
  {
    result: "grid_6",
    startX: 291.8646054426316,
    rows: 16,
  },
 
  {
    result: "grid_7",
    startX: 324.90208629016985,
    rows: 16,
  },
  {
    result: "grid_10",
    startX: 343.20987819490813,
    rows: 16,
  },
  
  {
    result: "grid_5",
    startX: 273.78997894263654,
    rows: 16,
  },
  {
    result: "grid_7",
    startX: 319.8617675483132,
    rows: 16,
  },
  {
    result: "grid_11",
    startX: 306.5030969355605,
    rows: 16,
  },
  {
    result: "grid_11",
    startX: 295.9015342201509,
    rows: 16,
  },
  {
    result: "grid_9",
    startX: 307.0271583992718,
    rows: 16,
  },
  {
    result: "grid_9",
    startX: 306.383306470533,
    rows: 16,
  },
  {
    result: "grid_4",
    startX: 310.81449242184254,
    rows: 16,
  },
  {
    result: "grid_3",
    startX: 269.1558863325794,
    rows: 16,
  },
  {
    result: "grid_3",
    startX: 322.2059612469249,
    rows: 16,
  },
  {
    result: "grid_6",
    startX: 297.0064998644493,
    rows: 16,
  },
  {
    result: "grid_6",
    startX: 325.34106099572506,
    rows: 16,
  },
  {
    result: "grid_7",
    startX: 289.5441680006428,
    rows: 16,
  },
  {
    result: "grid_11",
    startX: 311.5495368762048,
    rows: 16,
  },
  {
    result: "grid_11",
    startX: 286.32417887094675,
    rows: 16,
  },
  {
    result: "grid_8",
    startX: 324.05749715283304,
    rows: 16,
  },
  {
    result: "grid_8",
    startX: 292.575207459754,
    rows: 16,
  },
  {
    result: "grid_12",
    startX: 298.218859773731,
    rows: 16,
  },
  {
    result: "grid_12",
    startX: 327.77470998108566,
    rows: 16,
  },
 
  {
    result: "grid_8",
    startX: 275.9322106857923,
    rows: 16,
  },
  
  {
    result: "grid_7",
    startX: 323.03899424516413,
    rows: 16,
  },
 
  {
    result: "grid_10",
    startX: 320.1481276635698,
    rows: 16,
  },
  {
    result: "grid_16",
    startX: 342.9239850142262,
    rows: 16,
  },
 
 
  {
    result: "grid_8",
    startX: 307.4703967672307,
    rows: 16,
  },
 
  {
    result: "grid_4",
    startX: 300.8132363737584,
    rows: 16,
  },
  
  {
    result: "grid_9",
    startX: 335.36143883941315,
    rows: 16,
  },
  {
    result: "grid_9",
    startX: 293.93915245339366,
    rows: 16,
  },
  {
    result: "grid_5",
    startX: 271.5896179518168,
    rows: 16,
  },

  {
    result: "grid_10",
    startX: 290.48504771473625,
    rows: 16,
  },
  {
    result: "grid_11",
    startX: 311.5257760079147,
    rows: 16,
  },
 
 
  
  {
    result: "grid_14",
    startX: 305.804725947728,
    rows: 16,
  },
  
  {
    result: "grid_10",
    startX: 282.35027915211,
    rows: 16,
  },
  
  {
    result: "grid_8",
    startX: 318.7409234524009,
    rows: 16,
  },
  {
    result: "grid_4",
    startX: 269.34363558277573,
    rows: 16,
  },
  
  
  {
    result: "grid_5",
    startX: 301.04115528433016,
    rows: 16,
  },
  {
    result: "grid_11",
    startX: 293.62232217595823,
    rows: 16,
  },
  
  
  {
    result: "grid_12",
    startX: 303.8012761994362,
    rows: 16,
  },
  {
    result: "grid_5",
    startX: 318.24521574480735,
    rows: 16,
  },
  
  {
    result: "grid_8",
    startX: 268.24758551655657,
    rows: 16,
  },
 
  {
    result: "grid_6",
    startX: 322.3814993741954,
    rows: 16,
  },
 
  {
    result: "grid_12",
    startX: 312.0922158186153,
    rows: 16,
  },
  {
    result: "grid_12",
    startX: 349.0063607342211,
    rows: 16,
  },
 
  {
    result: "grid_5",
    startX: 274.9588223338588,
    rows: 16,
  },
  {
    result: "grid_2",
    startX: 297.32471037484845,
    rows: 16,
  },
 
  {
    result: "grid_9",
    startX: 292.691383964957,
    rows: 16,
  },
  {
    result: "grid_12",
    startX: 276.5559573682252,
    rows: 16,
  },
  
  {
    result: "grid_10",
    startX: 281.1019110768936,
    rows: 16,
  },
 
  {
    result: "grid_3",
    startX: 262.53559180808355,
    rows: 16,
  },
  
  {
    result: "grid_9",
    startX: 292.8924157414606,
    rows: 16,
  },
 
  {
    result: "grid_4",
    startX: 276.9769034753156,
    rows: 16,
  },
  
  {
    result: "grid_6",
    startX: 281.94428388430254,
    rows: 16,
  },
  {
    result: "grid_12",
    startX: 315.23626667599206,
    rows: 16,
  },
  {
    result: "grid_12",
    startX: 296.4221608792425,
    rows: 16,
  },
  

  {
    result: "grid_5",
    startX: 304.8156190286052,
    rows: 16,
  },
  {
    result: "grid_4",
    startX: 302.1008080397682,
    rows: 16,
  },
  
  {
    result: "grid_8",
    startX: 299.5527880936258,
    rows: 16,
  },
  

  
  {
    result: "grid_6",
    startX: 341.4749215160883,
    rows: 16,
  },
  
  {
    result: "grid_14",
    startX: 331.6949651574342,
    rows: 16,
  },
  {
    result: "grid_14",
    startX: 315.24869010451334,
    rows: 16,
  },
 
  
  {
    result: "grid_6",
    startX: 320.71975864766443,
    rows: 16,
  },
  {
    result: "grid_5",
    startX: 295.1208175001439,
    rows: 16,
  },
  
 
  {
    result: "grid_6",
    startX: 273.9170084100005,
    rows: 16,
  },
  {
    result: "grid_7",
    startX: 268.64439701398896,
    rows: 16,
  },

  
  {
    result: "grid_11",
    startX: 327.9619168867579,
    rows: 16,
  },
  {
    result: "grid_11",
    startX: 341.2794536312275,
    rows: 16,
  },
  {
    result: "grid_4",
    startX: 291.86907786215113,
    rows: 16,
  },
  {
    result: "grid_3",
    startX: 289.5996735609906,
    rows: 16,
  },

 
 
  {
    result: "grid_14",
    startX: 339.3972077231405,
    rows: 16,
  },
  {
    result: "grid_14",
    startX: 309.96370590366973,
    rows: 16,
  },
  
  {
    result: "grid_13",
    startX: 293.57687566644205,
    rows: 16,
  },
 
  {
    result: "grid_13",
    startX: 316.0103825138225,
    rows: 16,
  },
  {
    result: "grid_13",
    startX: 318.1126189848797,
    rows: 16,
  },
 
  {
    result: "grid_7",
    startX: 293.5781766394076,
    rows: 16,
  },
  {
    result: "grid_7",
    startX: 276.6895115220814,
    rows: 16,
  },
  
 
  {
    result: "grid_7",
    startX: 313.3406386136038,
    rows: 16,
  },
 
  
  {
    result: "grid_3",
    startX: 292.19636626225594,
    rows: 16,
  },
 
 
  {
    result: "grid_13",
    startX: 326.50856152204176,
    rows: 16,
  },
  
 

  {
    result: "grid_14",
    startX: 343.9477875793153,
    rows: 16,
  },
  
  
  
  {
    result: "grid_5",
    startX: 316.5417808877373,
    rows: 16,
  },
 
 
  
 
  {
    result: "grid_3",
    startX: 302.42115749132506,
    rows: 16,
  },
  
  
  {
    result: "grid_7",
    startX: 304.85730517105264,
    rows: 16,
  },
];